import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import styles from './RenewPage.module.css';

export default function RenewPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch(`/api/listings/renew/${token}`, { method: 'POST' })
      .then(r => r.json())
      .then(d => {
        if (d.success) { setStatus('success'); setMessage(d.message); }
        else { setStatus('error'); setMessage(d.error); }
      })
      .catch(() => { setStatus('error'); setMessage('Błąd połączenia z serwerem'); });
  }, [token]);

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {status === 'loading' && (
          <>
            <div className={styles.icon}>⟳</div>
            <h1>Przedłużanie ogłoszenia...</h1>
          </>
        )}
        {status === 'success' && (
          <>
            <div className={styles.iconSuccess}>✓</div>
            <h1>Gotowe!</h1>
            <p>{message}</p>
            <p className={styles.sub}>Ogłoszenie jest ponownie aktywne przez kolejne 30 dni.</p>
            <Link to="/moje-ogloszenia" className={styles.btn}>Przejdź do moich ogłoszeń</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className={styles.iconError}>✕</div>
            <h1>Coś poszło nie tak</h1>
            <p className={styles.sub}>{message}</p>
            <p className={styles.sub}>Link mógł już być użyty lub wygasnąć. Zaloguj się i przedłuż ogłoszenie ręcznie.</p>
            <Link to="/logowanie" className={styles.btn}>Zaloguj się</Link>
          </>
        )}
      </div>
    </div>
  );
}
